import {
    styled,
    Container as MuiContainer,
    Button as MuiButton,
} from "@mui/material";

export const Container = styled(MuiContainer)(({ theme }) => {
    return {
        paddingTop: "30px",
        paddingBottom: "104px",
        backgroundSize: "contain", // "70% auto",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "100%",
    };
});

export const Button = styled(MuiButton)(({ theme }) => {
    return {
        textTransform: "none",
    };
});
